"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadFeedbackEntity = void 0;
function parseILeadFeedbackEntity(data) {
    if (typeof data.occurred_at === 'string')
        data.occurred_at = new Date(data.occurred_at);
    if (typeof data.next_attempt_at === 'string')
        data.next_attempt_at = new Date(data.next_attempt_at);
    if (typeof data.last_attempt_at === 'string')
        data.last_attempt_at = new Date(data.last_attempt_at);
    if (typeof data.sent_at === 'string')
        data.sent_at = new Date(data.sent_at);
    if (typeof data.creation_date === 'string')
        data.creation_date = new Date(data.creation_date);
    return data;
}
exports.parseILeadFeedbackEntity = parseILeadFeedbackEntity;
